import FeatureName, { DefaultOnFeatures } from 'src/constants/featureName';
import { LOCAL_STORAGE_PREFIX } from '@constants/strings';

function localStorageKeyName(featureName: FeatureName) {
  return `${LOCAL_STORAGE_PREFIX}${featureName.toString()}`;
}

export function isFeatureOn(featureName: FeatureName) {
  const featureStatus = localStorage.getItem(localStorageKeyName(featureName));

  // To launch a feature, add it in DefaultOnFeatures
  if (featureStatus == null) {
    return DefaultOnFeatures.includes(featureName);
  }
  return featureStatus === String(true);
}

export function setFeatureStatus(featureName: FeatureName, status: boolean) {
  localStorage.setItem(localStorageKeyName(featureName), String(status));
}

export function resetFeatureStatus(featureName: FeatureName) {
  localStorage.removeItem(localStorageKeyName(featureName));
}

export function setAllFeaturesOn() {
  Object.keys(FeatureName).forEach((featureNameEnumKey) => {
    // eslint-disable-next-line
    // @ts-ignore
    const featureName = FeatureName[featureNameEnumKey] as FeatureName;
    setFeatureStatus(featureName, true);
  });
}

export function setAllFeaturesOff() {
  Object.keys(FeatureName).forEach((featureNameEnumKey) => {
    // eslint-disable-next-line
    // @ts-ignore
    const featureName = FeatureName[featureNameEnumKey] as FeatureName;
    setFeatureStatus(featureName, false);
  });
}

export function setAllFeaturesDefault() {
  Object.keys(FeatureName).forEach((featureNameEnumKey) => {
    // eslint-disable-next-line
    // @ts-ignore
    const featureName = FeatureName[featureNameEnumKey] as FeatureName;
    resetFeatureStatus(featureName);
  });
}
